import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import Notification from 'components/notification/Notification';
import classNames from 'classnames';
import Flex from 'components/common/Flex';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentLines } from '@fortawesome/pro-duotone-svg-icons';

const CommentsActivityLog = ({ activities, ...rest }) => {
  return (
    <Card {...rest}>
      <Card.Header className="bg-light">
        <Flex justifyContent="between">
          <h5 className="mb-1 mb-md-0">Latest Comments [SAMPLE DATA]</h5>
          <Link to="/social/activity-log" className="font-sans-serif">
            All logs
          </Link>
        </Flex>
      </Card.Header>
      <Card.Body className="p-0">
        {activities.map((activity, index) => (
          <Notification
            avatar={{ icon: faCommentLines }}
            children={activity.activity}
            time={`${moment(activity.date).fromNow()}`}
            time_detail={`${moment(activity.date).format('HH:mm MM/DD/YYYY')}`}
            // time_detail={moment.utc(activity.date)}
            key={activity.id}
            className={classNames(
              'border-x-0 border-bottom-0 border-300',
              index + 1 === activities.length ? 'rounded-top-0' : 'rounded-0'
            )}
          />
        ))}
      </Card.Body>
    </Card>
  );
};

// ActivityLog.propTypes = {
//   activities: PropTypes.arrayOf(PropTypes.shape(Notification.propTypes))
//     .isRequired
// };

export default CommentsActivityLog;
